import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { MapWeatherTokenApiInterceptor } from './token/api/map-weather-token-api.interceptor';
import { MapVesselPositionWeatherEffects } from './vessel-weather/state/map-vessel-position-weather.effects';

@NgModule({
    declarations: [],
    imports: [EffectsModule.forFeature([MapVesselPositionWeatherEffects])],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MapWeatherTokenApiInterceptor,
            multi: true,
        },
    ],
})
export class MapWeatherDataAccessModule {}
